export const CROPPER_PRESET_TYPES = {
  RATIO: 'RATIO',
  SIZE: 'SIZE'
}

export const mapControls = {
  adjust: [
    {
      name: 'brightness',
      label: 'Brightness',
      min: -50,
      max: 50,
      id: 1,
    },
    {
      name: 'contrast',
      label: 'Contrast',
      min: -60,
      max: 100,
      id: 2,
    },
    {
      name: 'saturation',
      label: 'Saturation',
      min: -100,
      max: 100,
      id: 3,
    },
  ],
  filters: [
    {
      name: 'grayscale',
      label: 'Grayscale',
      min: 0,
      max: 100,
      id: 1,
    },
    {
      name: 'dogpatch',
      label: 'Dogpatch',
      min: 0,
      max: 100,
      id: 2,
    },
    {
      name: 'aden',
      label: 'Aden',
      min: 0,
      max: 100,
      id: 3,
    },
    {
      name: 'hudson',
      label: 'Hudson',
      min: 0,
      max: 100,
      id: 4,
    },
    {
      name: 'perpetua',
      label: 'Perpetua',
      min: 0,
      max: 100,
      id: 5,
    },
  ],
  cropper: [
    {
      name: 'freeform',
      type: null,
      w: null,
      h: null,
      id: 0,
    },
    {
      name: '1x1',
      type: CROPPER_PRESET_TYPES.RATIO,
      w: 1,
      h: 1,
      id: 1,
    },
    {
      name: '3x2',
      type: CROPPER_PRESET_TYPES.RATIO,
      w: 3,
      h: 2,
      id: 2,
    },
    {
      name: '4x3',
      type: CROPPER_PRESET_TYPES.RATIO,
      w: 4,
      h: 3,
      id: 3,
    },
    {
      name: '4x6',
      type: CROPPER_PRESET_TYPES.RATIO,
      w: 4,
      h: 6,
      id: 4,
    },
    {
      name: '5x7',
      type: CROPPER_PRESET_TYPES.RATIO,
      w: 5,
      h: 7,
      id: 5,
    },
    {
      name: '16x9',
      type: CROPPER_PRESET_TYPES.RATIO,
      w: 16,
      h: 9,
      id: 6,
    },
    {
      name: 'golden-ratio',
      type: CROPPER_PRESET_TYPES.RATIO,
      w: 3.2360679774998,
      h: 2,
      id: 7,
    },
    {
      name: 'facebook-cover',
      type: CROPPER_PRESET_TYPES.SIZE,
      w: 820,
      h: 312,
      id: 8,
    },
    {
      name: 'twitter-header',
      type: CROPPER_PRESET_TYPES.SIZE,
      w: 1500,
      h: 500,
      id: 9,
    },
    {
      name: 'youtube-banner',
      type: CROPPER_PRESET_TYPES.SIZE,
      w: 2560,
      h: 1440,
      id: 10,
    },
    {
      name: 'pinterest-pin',
      type: CROPPER_PRESET_TYPES.SIZE,
      w: 735,
      h: 1102,
      id: 11,
    },
    {
      name: 'instagram-stories',
      type: CROPPER_PRESET_TYPES.SIZE,
      w: 1080,
      h: 1920,
      id: 12,
    },
  ]
}
